// Shared pricing config for V1 (used by /subscribe and the public landing page).
export const COMMUNITY_FEATURES = [
  "12-Step Business Foundation Guide",
  "Readiness Diagnostic",
  "Progress tracking",
];

export const PRO_FEATURES = [
  "Simulated Load Board — learn to book profitable loads",
  "AI Coach — owner-operator answers on demand",
  "Cost-Per-Mile Calculator with peer benchmarks",
];

export const PRO_PLANS = {
  monthly: { id: "monthly", label: "Monthly", price: "$49", per: "/mo", sub: "Billed monthly. Cancel anytime." },
  annual: { id: "annual", label: "Annual", price: "$39", per: "/mo", sub: "Billed $468 once a year — save $120." },
};

// Annual saves $120/yr vs monthly ($49 x 12 = $588 vs $468).
export const ANNUAL_SAVINGS = "Save $120/yr";
